import { forgetPasswordApi, resetPasswordApi } from "services/authServcies";
import {
  userForgetPasswordSuccess,
  userForgetPasswordError,
  userResetPasswordSuccess,
  userResetPasswordError,
  resetForgetPasswordFlag,
  resetResetPasswordFlag,
} from "./reducer";

export const userForgetPassword =
  (user: any, history: any) => async (dispatch: any) => {
    try {
      const response = await forgetPasswordApi({ username: user.username,  emailid: user.email, });

      if (response.success) {
        dispatch(
          userForgetPasswordSuccess({
            message: response.message || "OTP sent. Redirecting...",
            email: user.email,
            username: user.username
          })
        );

        history("/reset-password");
        setTimeout(() => {
          dispatch(resetForgetPasswordFlag());
        }, 5000);
      }
    } catch (forgetError: any) {
      const errorMessage =
        forgetError?.message ||
        forgetError?.response?.data?.message ||
        "Something went wrong";
      dispatch(userForgetPasswordError(errorMessage));
    }      
  };

export const userResetPassword =
  (data: any, history: any) => async (dispatch: any) => {
    try {

      const response = await resetPasswordApi(data);

      if (response.success) {
        dispatch(
          userResetPasswordSuccess(
            "Password reset successfull. Redirecting to Login page..."
          )
        );
        //history("/login");
        setTimeout(() => {
          dispatch(resetResetPasswordFlag());
        }, 5000);
      }
    } catch (resetError: any) {
      const errorMessage =
        resetError?.message ||
        resetError?.response?.data?.message ||
        "Something went wrong";
      dispatch(userResetPasswordError(errorMessage));
    }
  };
